
import { locales } from '@/utils/locales'

const regionFor = code => {
  const match = locales.find(locale => locale.code === code)
  return match ? match.country : 'FR'
}

export default {
  name: 'GoogleStoreWidget',
  props: {
    enabled: { type: Boolean, default: true },
    position: { type: String, default: 'LEFT_BOTTOM' },
    sideMargin: { type: Number, default: 36 },
    bottomMargin: { type: Number, default: 80 },
    mobileSideMargin: { type: Number, default: 16 },
    mobileBottomMargin: { type: Number, default: 16 },
  },
  mounted() {
    if (!process.client || !this.enabled) return
    this.scheduleLoad()
  },
  beforeDestroy() {
    if (process.client) this.cleanup()
  },
  methods: {
    scheduleLoad() {
      if (!window.Cookiebot?.consent?.statistics) {
        window.addEventListener('CookiebotOnAccept', this.onCookieAccept, {
          once: true,
        })
        return
      }

      const load = () => setTimeout(() => this.loadScript(), 3000)

      if ('requestIdleCallback' in window) {
        requestIdleCallback(load, { timeout: 5000 })
      } else {
        load()
      }
    },

    onCookieAccept() {
      if (window.Cookiebot?.consent?.statistics) {
        this.scheduleLoad()
      }
    },

    loadScript() {
      if (document.getElementById('merchantWidgetScript')) {
        this.init()
        return
      }

      const script = document.createElement('script')
      script.id = 'merchantWidgetScript'
      script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js'
      script.defer = true
      script.onload = () => this.init()
      document.head.appendChild(script)
    },

    init() {
      if (!window.merchantwidget?.start) return
      if (document.getElementById('google-merchantwidget-iframe-wrapper')) {
        return
      }

      window.merchantwidget.start({
        position: this.position,
        sideMargin: this.sideMargin,
        bottomMargin: this.bottomMargin,
        mobileSideMargin: this.mobileSideMargin,
        mobileBottomMargin: this.mobileBottomMargin,
        region: regionFor(this.$i18n?.locale),
      })
    },

    cleanup() {
      window.removeEventListener('CookiebotOnAccept', this.onCookieAccept)

      window.merchantwidget?.stop?.()

      document
        .querySelectorAll('[id*="merchant"], [class*="merchant"]')
        .forEach(el => el.remove())

      const script = document.getElementById('merchantWidgetScript')
      script?.remove()

      if (window.merchantwidget) {
        window.merchantwidget = undefined
      }
    },
  },
}
